import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import editapi from '../api/courseStudentListRouter';
import sadminapi from '../api/sadminapi';
import loginapi from '../api/login';

import { APISERVERURL } from '../APIServerURL';
const gradeOptions = ["","elective", "core"];
const CourseTable = ({ data,onSave,onDownload }) => {
   const [courses, setCourses] = useState(data);

  const handleGradeChange = (index, newType) => {
    const updated = [...courses];
    updated[index].course_type = newType;
    setCourses(updated);
  };

  const handleSave = () => {
    onSave(courses);
  };
    const handleDownload = () => {
    onDownload();
  };

  return (
    <div className="w-full flex flex-col justify-start items-center p-1">
    <div className="min-w-full overflow-x-auto">
      <table className="min-w-full border border-gray-300 rounded-lg mt-4 text-sm">
        <thead className="bg-gray-200">
          <tr>
            <th className="border px-4 py-2">Sl. No.</th>
            <th className="border px-4 py-2">Session</th>
            <th className="border px-4 py-2">Roll No</th>
            <th className="border px-4 py-2">Semester</th>
            <th className="border px-4 py-2">Course Code</th>
            <th className="border px-4 py-2">Course Title</th>
            <th className="border px-4 py-2">Course Type</th>
              <th className="border px-4 py-2 bg-yellow-100">Change Course Type</th>
            <th className="border px-4 py-2">Credit</th>
            <th className="border px-4 py-2">Grade</th>
          </tr>
        </thead>
        <tbody>
          {courses.map((item, index) => (
            <tr key={index} className="text-center">
              <td className="border px-4 py-2">{index + 1}</td>
              <td className="border px-4 py-2">{item.session}</td>
              <td className="border px-4 py-2">{item.rollno}</td>
              <td className="border px-4 py-2">{item.semester}</td>
              <td className="border px-4 py-2">{item.course_code}</td>
              <td className="border px-4 py-2">{item.title}</td>
              <td className="border px-4 py-2">{item.course_type}</td>
              <td className="min-w-[140px] px-4 py-2 border bg-yellow-100">
                <select
                  value={item.course_type}
                  onChange={(e) => handleGradeChange(index, e.target.value)}
                  className="border rounded px-2 py-1 w-full"
                >
                  {gradeOptions.map((grade) => (
                    <option key={grade} value={grade}>
                      {grade}
                    </option>
                  ))}
                </select>
              </td>
              <td className="border px-4 py-2">{item.credit}</td>
              <td className="border px-4 py-2">{item.grade}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
       <div className="w-full mt-4 ">
        {true && ( <div className="w-full flex justify-between">
  <button
    onClick={handleSave}
    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
  >
    Save Changes
  </button> 
  <button
    onClick={handleDownload}
    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
  >
    Download CSV
  </button> 

</div>)}
      </div>
    </div>
    
  );
};


function CourseStudentList({accessToken,setAccessToken,setRefreshFailed  }) {
  const navigate = useNavigate();
  const [rollno,setRollno]=useState('');
  const [error,setError]=useState('');

  const [isSearching,setIsSearching]=useState(false);
const [studentList,setStudentList]=useState([]);
 const [isDownloading,setIsDownloading]=useState(false);
  const handleGoBack = () => {
    navigate(`/`); 
  };

function downloadFile(fname)
      {
        fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
          response.blob().then((blob) => {
           
              // Creating new object of PDF file
              const fileURL =
                  window.URL.createObjectURL(blob);
                   
              // Setting various property values
              let alink = document.createElement("a");
              alink.href = fileURL;
              alink.download = fname;
              alink.click();
              //setIsloading(false);
          });
        });
      }
  
    async function handleDownloadCSV()
      {
        //e.preventDefault();
        setIsDownloading(true);
        try{
          const response= await editapi.post('/downloadCourseStudentList',{code:rollno.trim()},{headers:{'Authorization':`Bearer ${accessToken}`}});    
          alert(response.data);
          downloadFile(response.data);
        }
        catch(err)
        {
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);
            
            const nat=x['data']['accessToken'];
            setAccessToken(nat);
            try{       
              const response= await editapi.post('/downloadCourseStudentList',{code:rollno.trim()},{headers:{'Authorization':`Bearer ${nat}`}});    
              downloadFile(response.data);
             }
             catch(err)
             {
              alert('unusual error newposts.js');
             }
          }
          catch(err)
          {
            alert('failed');
          }
  
        }
        finally{
          setIsDownloading(false);
        }
      }

const handleRollnoChange = (e) => {
    setRollno(e.target.value.toUpperCase().trim());
  };

 
    
    async function handleSearch(e)
        {
          //e.preventDefault();
          setStudentList([]);   
          setIsSearching(true);
          try{
            const response= await editapi.post('/getStdentListOfTheCourse',{ code:rollno.trim()},{headers:{'Authorization':`Bearer ${accessToken}`}});    
            //alert(JSON.stringify(response.data));
            setStudentList(response.data.list);           ;
                      }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await editapi.post('/getStdentListOfTheCourse',{ code:rollno.trim()},{headers:{'Authorization':`Bearer ${nat}`}});  
                 setStudentList(response.data.list);               
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
          finally
          {
            setIsSearching(false);
          }
        }

async function handleSave(courses)
        {
          try{
            const response= await sadminapi.post('/updateCourseType',{ courses},{headers:{'Authorization':`Bearer ${accessToken}`}});    
            alert("DONE");
              await handleSearch();
              
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await sadminapi.post('/updateCourseType',{ courses},{headers:{'Authorization':`Bearer ${nat}`}});    
                       //setResult(response.data.result);   alert("OK"); 
                                   alert("DONE");
                       await handleSearch();
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
        }

  return (
     <main className="w-full">
         <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center"> STUDENT LIST OF A COURSE</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(The form is autosave)</p>    
          </div>

    

      <div className="flex flex-col justify-center gap-4 mt-4">
       
        
        

        <div className="w-full flex items-center justify-center mt-4 ">
                <div
                  className="text-center w-full max-w-[600px]  grid grid-cols-[1fr_3fr_1fr] gap-2 p-1 text-sm align-items-end "
                >
                <label className="px-2 py-2">COURSE CODE:</label>

                <input
                                type="text" 
                                name="txtRollno"
                                value={rollno}
                                onChange={handleRollnoChange}
                              className="w-full p-2 mt-1 bg-transparent border-b border-gray-400 focus:border-green-500 focus:border-b outline-none transition-all"
                              />
              <button className="bg-green-500 text-white font-semibold px-6 py-2 rounded-full shadow-md transition-all duration-300 hover:bg-green-600 hover:scale-105 active:scale-95"
              onClick={handleSearch}>
                SEARCH
              </button>

                </div>
        </div>    
           
    {studentList.length>0 && (<div className="w-full">
     
        <h2 className="text-lg font-semibold mb-1 text-center">Students opting for the Course</h2>
        <CourseTable data={studentList} onSave={handleSave} onDownload={handleDownloadCSV}/>
    
    </div>
    )}

      </div>
      </div>
    </main>
  );
}

export default CourseStudentList;
